class LMSDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-close]').forEach((button) =>
      button.addEventListener('click', () => this.close())
    );

    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });
  }

  open() {
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.body.classList.add('no-scroll');
    this.querySelector('button,[href],input')?.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(() => (this.hidden = true), 250);
  }
}

customElements.define('lms-drawer', LMSDrawer);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drawer]');

  if (trigger) {
    const drawer = document.getElementById(trigger.dataset.drawer);
    drawer?.open();
  }
});

document.addEventListener('keyup', (event) => {
  if (event.key === 'Escape') {
    document
      .querySelectorAll('lms-drawer.is-open')
      .forEach((drawer) => drawer.close());
  }
});

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');

    if (!this.form) return;

    this.variantInput = this.form.querySelector('[name="id"]');
    this.submitButton = this.form.querySelector('[type="submit"]');
    this.variantDataElement = this.querySelector('[data-product-variants]');

    try {
      this.variants = JSON.parse(this.variantDataElement?.textContent || '[]');
    } catch {
      this.variants = [];
    }

    this.form.addEventListener('change', (event) => {
      if (event.target.matches('.product-options input[type="radio"]')) {
        this.updateSelectedVariant();
      }
    });

    this.form.addEventListener('submit', (event) => {
      if (!this.variantInput?.value || this.submitButton?.disabled) {
        event.preventDefault();
        return;
      }

      this.submitButton.setAttribute('aria-busy', 'true');
    });

    this.updateSelectedVariant(false);
  }

  getSelectedOptions() {
    return Array.from(
      this.form.querySelectorAll('.product-options fieldset')
    ).map((fieldset) => fieldset.querySelector('input:checked')?.value);
  }

  updateSelectedVariant(updateUrl = true) {
    const selectedOptions = this.getSelectedOptions();
    let variant;

    if (selectedOptions.length) {
      variant = this.variants.find(
        (candidate) =>
          candidate.options.length === selectedOptions.length &&
          candidate.options.every(
            (option, index) => option === selectedOptions[index]
          )
      );
    } else {
      variant =
        this.variants.find(
          (candidate) =>
            String(candidate.id) === String(this.variantInput?.value)
        ) || this.variants[0];
    }

    if (this.variantInput) {
      this.variantInput.value = variant?.id || '';
      this.variantInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    if (this.submitButton) {
      const isAvailable = Boolean(variant?.available);
      this.submitButton.disabled = !isAvailable;
      this.submitButton.textContent = variant
        ? isAvailable
          ? this.submitButton.dataset.addToCartText
          : this.submitButton.dataset.soldOutText
        : this.submitButton.dataset.unavailableText;
    }

    if (variant && updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }
}

customElements.define('product-form', ProductForm);

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-media-target]').forEach((button) =>
      button.addEventListener('click', () => {
        this.querySelectorAll('[data-media]').forEach((media) => {
          media.hidden = media.dataset.media !== button.dataset.mediaTarget;
        });

        this.querySelectorAll('[data-media-target]').forEach((item) => {
          item.setAttribute('aria-current', item === button ? 'true' : 'false');
        });
      })
    );
  }
}

customElements.define('product-gallery', ProductGallery);

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;

    if (handle) {
      let items = JSON.parse(
        localStorage.getItem('lms-recent') || '[]'
      ).filter((item) => item !== handle);

      items.unshift(handle);
      localStorage.setItem(
        'lms-recent',
        JSON.stringify(items.slice(0, 8))
      );
    }
  }
}

customElements.define('recently-viewed', RecentlyViewed);

document.addEventListener('click', (event) => {
  const wish = event.target.closest('[data-wishlist]');

  if (!wish) return;

  let list = JSON.parse(
    localStorage.getItem('lms-wishlist') || '[]'
  );

  const handle = wish.dataset.wishlist;

  list = list.includes(handle)
    ? list.filter((item) => item !== handle)
    : [...list, handle];

  localStorage.setItem('lms-wishlist', JSON.stringify(list));
  wish.classList.toggle('active');
  wish.setAttribute(
    'aria-pressed',
    wish.classList.contains('active')
  );
});